import styled, { css } from 'styled-components';
import theme from '../../theme';

const ButtonContained = styled.button<{
    $primaryColor: boolean;
}>`
    color: ${({ $primaryColor }) => $primaryColor ? theme.white : theme.primaryColor};
    background-color: ${({ $primaryColor }) => $primaryColor ? theme.primaryColor : theme.white};
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;

    &:disabled {
        background-color: #ccc;
        color: ${theme.white};
        cursor: default;
    }

    &:hover {
        ${({ $primaryColor }) => $primaryColor ? css`
            background-color: rgba(91,60,196, 0.9);
        ` : css``
        };
        -webkit-transition: 0.3s;
        -moz-transition: 0.3s;
        -ms-transition: 0.3s;
        -o-transition: 0.3s;
        transition: 0.3s;
    }

    &:hover:disabled {
        background-color: #cccccc;
    }
`;

const ButtonOutlined = styled(ButtonContained)`
    color: ${theme.primaryColor};
    background-color: ${theme.white};
    border: 2px solid ${theme.primaryColor};
    padding: 10px 24px;
    
    &:disabled {
        border: 2px solid #ccc;
    }

    &:hover {
        background-color: ${theme.primaryColor}10;
    }
`;

const ButtonLabel = styled(ButtonContained)`
    color: ${theme.primaryColor};
    background-color: transparent;
    border: 2px solid transparent;
    padding: 10px 24px;
    
    &:disabled {
        border: 2px solid transparent;
    }

    &:hover {
        background-color: transparent;
    }
`;

export { ButtonContained, ButtonOutlined, ButtonLabel };